import { Builder } from '@builder.io/react';
import Buttons from './buttons';
import theme from '../../gatsby-plugin-theme-ui-v1';

Builder.registerComponent(Buttons, {
  name: 'Buttons',
  static: true,
  inputs: [
    {
      name: 'justifyContent',
      type: 'string',
      enum: [
        'flex-start',
        'flex-end',
        'center',
        'space-between',
        'space-around',
        'space-evenly',
      ],
      defaultValue: 'flex-start',
      required: true,
      advanced: true,
    },
    {
      name: 'buttons',
      type: 'list',
      subFields: [
        {
          name: 'label',
          type: 'string',
          required: true,
          autofocus: true,
          defaultValue: 'Click me!',
        },
        {
          name: 'uppercase',
          type: 'boolean',
        },
        {
          name: 'linkUrl',
          type: 'string',
          required: true,
          defaultValue: 'https://www.harrys.com/',
        },
        {
          name: 'variant',
          type: 'string',
          required: true,
          enum: [...Object.keys(theme.buttons)],
          defaultValue: 'primary',
        },
      ],
      defaultValue: [
        {
          label: 'Shop now',
          linkUrl: 'https://www.harrys.com',
          variant: 'primary',
          justifyContent: 'flex-start',
          uppercase: true
        },
      ],
    },
  ],
});
